export default {
  styleOverrides: {
    root: {
      padding: "0 6px",
    },
  },
};
